<template>
  <div class="container-fluid" style="margin: 2em">
    <form>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">应用名称</label>
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="app.appName" placeholder="" />
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">短链接</label>
        <div class="col-sm-4" style="display: inline; white-space: normal nowrap">
          <input type="email" class="form-control" v-model="app.shortLink" />
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">应用图标</label>
        <div class="col-sm-10" style="text-align: left">
          <img
            v-if="app.iConData"
            style="border-radius: 1em; width: 8em"
            :src="app.iConData"
          />
          <img style="border-radius: 1em; width: 8em" :src="app.iConUrl" />
          <button
            @click="update_icon"
            type="button"
            style="width: 4em; height: 2.5em"
            class="btn btn-primary"
          >
            更新
          </button>
          <input @change="upload_icon" type="file" id="icon_file" style="display: none" />
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">应用价格</label>
        <div class="col-sm-3">
          <input type="text" class="form-control" v-model="app.price" placeholder="" />
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">应用类型</label>
        <div style="text-align: left" class="col-sm-10">
          <el-select
            @change="changeAppType(app.appType)"
            style="text-align: left"
            v-model="app.appType"
            placeholder="请选择"
          >
            <el-option key="0" label="请选择" :value="0"> </el-option>
            <el-option key="1" label="游戏" :value="1"> </el-option>
            <el-option key="2" label="应用" :value="2"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">应用分类</label>
        <div style="text-align: left" class="col-sm-10">
          <el-select
            @change="changeAcType(app.acType)"
            style="text-align: left"
            v-model="app.acType"
            placeholder="请选择"
          >
            <el-option key="0" label="未设置" :value="0"> </el-option>
            <el-option key="1" label="游戏" :value="1"> </el-option>
            <el-option key="2" label="应用" :value="2"> </el-option>
          </el-select>
          <el-select v-model="app.appCategoryId" placeholder="请选择">
            <el-option
              v-for="(v, index) in appCategoryList"
              :key="index"
              :value="v.id"
              :label="v.name"
            />
          </el-select>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">购买链接</label>
        <div class="col-sm-3">
          <input
            type="text"
            class="form-control"
            v-model="app.taobaoUrl"
            placeholder=""
          />
        </div>
        <div>
          <el-radio @change="getTaoBaoBySysConfigCode('')" v-model="radio" label="1"
            >输入链接</el-radio
          >
          <el-radio
            @change="getTaoBaoBySysConfigCode('TEN_RMB_URL')"
            v-model="radio"
            label="2"
            >10元链接</el-radio
          >
          <el-radio
            @change="getTaoBaoBySysConfigCode('TWENTY_RMB_URL')"
            v-model="radio"
            label="3"
            >20元链接</el-radio
          >
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">排序规则</label>
        <div class="col-xs-3" style="margin-left: 1em">
          <el-radio v-model="app.sortFlag" :label="1">正常</el-radio>
          <el-radio v-model="app.sortFlag" :label="2">置顶</el-radio>
          <el-radio v-model="app.sortFlag" :label="3">置底</el-radio>
        </div>
      </div>
      <div v-if="app.useSuperSign" class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label"
          >超级签最大安装限制</label
        >
        <div class="col-sm-3">
          <input
            type="text"
            class="form-control"
            v-model="app.maxInstallNum"
            placeholder=""
          />
        </div>
        <!-- <label style="margin-left:-2em;" class="col-sm-2 col-form-label">已下载安装 {{app.installNum}} 次</label> -->
      </div>
      <!-- <div v-if="app.osName=='iOS'" class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1">启用超级签名</label>
        <el-popover placement="top-start" trigger="hover" content="启用开关设置，点击保存按钮">
          <el-switch slot="reference" style="margin-left:2em" v-model="app.useSuperSign"></el-switch>
        </el-popover>
      </div> -->
      <div v-if="app.useSuperSign" class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1"
          >启用私有开发者账号签名</label
        >
        <el-popover
          placement="top-start"
          trigger="hover"
          content="启用开关设置，点击保存按钮"
        >
          <el-switch
            slot="reference"
            style="margin-left: 2em"
            v-model="app.usePrivateAppledeveloperAccount"
          ></el-switch>
        </el-popover>
      </div>
      <div v-if="app.useSuperSign" class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1"
          >启用安全码下载</label
        >
        <el-popover
          placement="top-start"
          trigger="hover"
          content="启用开关设置，点击保存按钮"
        >
          <el-switch
            slot="reference"
            style="margin-left: 2em"
            v-model="app.useDownloadCode"
          ></el-switch>
        </el-popover>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1"
          >移除embedded</label
        >
        <el-popover
          placement="top-start"
          trigger="hover"
          content="启用开关设置，点击保存按钮"
        >
          <el-switch
            slot="reference"
            style="margin-left: 2em"
            v-model="app.removeEmbedded"
          ></el-switch>
        </el-popover>
      </div>
      <div v-if="app.useSuperSign" class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1"
          >小程序显示</label
        >
        <el-popover
          placement="top-start"
          trigger="hover"
          content="启用开关设置，点击保存按钮"
        >
          <el-switch
            slot="reference"
            style="margin-left: 2em"
            v-model="app.miniAppShow"
          ></el-switch>
        </el-popover>
      </div>
      <div v-if="app.useSuperSign" class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1"
          >热更新</label
        >
        <el-popover
          placement="top-start"
          trigger="hover"
          content="启用开关设置，点击保存按钮"
        >
          <el-switch
            slot="reference"
            style="margin-left: 2em"
            v-model="app.hotUpdate"
          ></el-switch>
        </el-popover>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">应用来源</label>
        <div style="text-align: left" class="col-sm-10">
          <el-select style="text-align: left" v-model="app.appFrom" placeholder="请选择">
            <el-option key="1" label="平台" :value="1"></el-option>
            <el-option key="2" label="Apple Store" :value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">第三方下载链接</label>
        <div class="col-sm-3">
          <input
            type="text"
            class="form-control"
            v-model="app.thirdDownloadUrl"
            placeholder=""
          />
        </div>
      </div>
      <!-- <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label">在线安装描述</label>
        <div class="col-sm-10">
          <quill-editor ref="text" v-model="app.onlineInstallExplain" class=".editor" :options="editorOption" />
        </div>
      </div> -->
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="exampleFormControlTextarea1"
          >应用描述</label
        >
        <div class="col-sm-10">
          <textarea class="form-control" v-model="app.appDesc" rows="5"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabel" class="col-sm-2 col-form-label"></label>
        <div style="text-align: left" class="col-sm-10">
          <button
            type="button"
            @click="del_app(app.shortLink)"
            class="btn btn-outline-warning"
          >
            删除
          </button>
          <button
            type="button"
            @click="update_app(app.shortLink)"
            class="btn btn-success"
          >
            保存
          </button>
        </div>
      </div>
      <div class="form-group row"></div>
    </form>
  </div>
</template>

<script>
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  // ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  // [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  // [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  // [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  // [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  // [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  // [{ font: [] }], // 字体种类-----[{ font: [] }]
  // [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  // ["image", "video"] // 链接、图片、视频-----['link', 'image', 'video']
];
var self;
export default {
  name: "HelloWorld",
  data() {
    return {
      editorOption: {
        //  富文本编辑器配置
        modules: {
          //工具栏定义的
          toolbar: toolbarOptions,
        },
        //主题
        theme: "snow",
        placeholder: "请输入正文",
      },
      app: {},
      iconId: null,
      appCategoryList: [],
      appCategoryId: null,
      radio: "1",
      sortRadio: "2",
    };
  },
  mounted() {
    self = this;
    var shortLink = this.$route.params.shortLink;
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/app/info", {
        link: shortLink,
        authToken: this.getToken(),
      })
      .then((response) => {
        this.respDataHandle(response.body, (respData) => {
          this.app = respData;
          this.getAppCategoryList(respData.acType);
          this.$emit("setApp", respData);
        });
      });
  },
  methods: {
    del_app: function (link) {
      this.delete_app(link, function () {
        self.$router.push("/apps");
      });
    },
    update_app: function (link) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/update", {
          id: this.app.id,
          shortLink: link,
          appDesc: this.app.appDesc,
          appName: this.app.appName,
          iconId: this.iconId,
          authToken: this.getToken,
          useSuperSign: this.app.useSuperSign,
          useDownloadCode: this.app.useDownloadCode,
          maxInstallNum: this.app.maxInstallNum,
          usePrivateAppledeveloperAccount: this.app.usePrivateAppledeveloperAccount,
          price: this.app.price,
          appCategoryId: this.app.appCategoryId,
          taobaoUrl: this.app.taobaoUrl,
          appType: this.app.appType,
          shortLink: this.app.shortLink,
          sortFlag: this.app.sortFlag,
          miniAppShow: this.app.miniAppShow,
          onlineInstallUrl: this.app.onlineInstallUrl,
          onlineInstallExplain: this.app.onlineInstallExplain,
          hotUpdate: this.app.hotUpdate,
          appFrom: this.app.appFrom,
          thirdDownloadUrl: this.app.thirdDownloadUrl,
          removeEmbedded: this.app.removeEmbedded,
        })
        .then((response) => {
          this.respDataHandle(response.body, (data) => {
            if (data) {
              window.layer.msg("修改成功");
            }
          });
        });
    },
    update_icon: function () {
      $("#icon_file").click();
    },
    upload_icon: function (event) {
      console.log("读取文件");
      var file = event.target.files[0];
      var fileType = file.name.substr(file.name.length - 3, file.name.length);
      if (fileType != "png" && fileType != "jpg" && fileType != "jpeg") {
        this.errToastr("请上传png、jpg、jpeg格式文件");
        return;
      }
      var formdata = new FormData();
      formdata.append("file", file);
      formdata.append("authToken", this.getToken());
      formdata.append("appId", this.app.id);
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/icon/upload", formdata)
        .then((response) => {
          self.respDataHandle(response.body, function (data) {
            console.log(data);
            self.iconId = data.id;
            self.app.iConData = data.iData;
          });
        });
    },
    getAppCategoryList: function (acType) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/app/categoryByType", {
          type: acType,
        })
        .then((response) => {
          this.respDataHandle(response.body, (data) => {
            this.appCategoryList = data;
          });
        });
    },
    changeAcType: function (acType) {
      console.log("acType", acType);
      if (acType != null && acType != undefined) {
        this.getAppCategoryList(acType);
      }
    },
    getTaoBaoBySysConfigCode: function (code) {
      if (code == "") {
        return;
      }
      this.$http
        .post(this._Global.HTTP_SERVER + "/sysConfig/getValueByCode", {
          code: code,
        })
        .then((response) => {
          this.respDataHandle(response.body, (data) => {
            this.app.taobaoUrl = data.scValue;
          });
        });
    },
  },
};
</script>

<style scoped>
button {
  border-radius: 5em;
  width: 6em;
}
</style>



// WEBPACK FOOTER //
// src/components/AppEdit.vue